'use strict';

export function generateRecaptcha(formElement, callBack) {

    const loadingCtaModifier = 'cta--loading';
    function showSubmitCTASpinner(ctaSubmitElement) {
        if (ctaSubmitElement.classList.contains('cta') && !ctaSubmitElement.classList.contains(loadingCtaModifier)) {
            ctaSubmitElement.classList.add(loadingCtaModifier);
            ctaSubmitElement.setAttribute('disabled', 'disabled');
            const loaderElement = document.createElement('span');
            loaderElement.classList.add('loader');
            ctaSubmitElement.append(loaderElement);
        }
    }

    function hideSubmitCTASpinner(ctaSubmitElement) {
        if (ctaSubmitElement.classList.contains('cta') && ctaSubmitElement.classList.contains(loadingCtaModifier)) {
            ctaSubmitElement.classList.remove(loadingCtaModifier);
            ctaSubmitElement.removeAttribute('disabled');
            const loaderElement = ctaSubmitElement.querySelector('.loader');
            ctaSubmitElement.removeChild(loaderElement);
        }
    }

    let ctaSubmitElement = formElement.querySelector('[type=\"submit\"]') ?? document.querySelector(`[form="${formElement.id}"]`);
    formElement.addEventListener('submit', function (e) {
        e.preventDefault();

        if (!e.target.reportValidity())
            return;

        showSubmitCTASpinner(ctaSubmitElement);

        if (typeof grecaptcha.ready === 'function') {
            grecaptcha.ready(function () {
                grecaptcha.execute(
                    ctaSubmitElement.getAttribute("data-sitekey"), {
                    action: ctaSubmitElement.getAttribute("data-action")
                }).then(function (token) {
                    if (token) {
                        let response = formElement.querySelector('[name=\"g-recaptcha-response\"]');
                        if (response) {
                            response.value = token;
                        }
                        else {
                            let elt = document.createElement("input");
                            elt.hidden = true;
                            elt.name = "g-recaptcha-response";
                            elt.value = token;
                            formElement.insertBefore(elt, ctaSubmitElement);
                        }

                        callBack(() => hideSubmitCTASpinner(ctaSubmitElement));
                    }
                });
            });
        }
        else {
            callBack(() => hideSubmitCTASpinner(ctaSubmitElement));
        }
    });
}
